import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../hooks/hooks";
import { selectCurrent } from "../../../../redux/settings/selectors";
import PageLoader from "../../../../components/PageLoader";
import { selectGlobalDbnTaxonomyCategoriesCompareItem, selectGlobalDbnTaxonomyCategoriesCreatedItem, selectGlobalDbnTaxonomyCategoriesDeletedItem, selectGlobalDbnTaxonomyCategoriesListItems, selectGlobalDbnTaxonomyCategoriesUpdatedItem } from "../../../../redux/global-dbn-taxonomy-categories/selector";
import { globalDbnTaxonomyCategories } from "../../../../redux/global-dbn-taxonomy-categories/action";
import { settings } from "../../../../redux/settings/actions";
import UploadCommonModal from "../../../../models/upload-common-modal";
import { toast } from "react-toastify";
import Table from "../../../../common/components/table-manager/v1.1/table";
import Popup from "../../../../common/components/popup";
import GlobalDbnTaxonomyCompareCategories from "../../global-dbn-taxonomy-categories/containers/global-dbn-taxonomy-compare-categories";
import { selectGlobalDbnServiceCategoriesListItems } from "../../../../redux/global-dbn-service-category/selector";
import { globalDbnServiceCategories } from "../../../../redux/global-dbn-service-category/action";
import { routingModels } from "../../../../redux/global-dbn-routing-models/action";
import { selectRoutingModelsListItems } from "../../../../redux/global-dbn-routing-models/selector";
import { selectListItems } from "../../../../redux/library/selector";
import { routingPacks } from "../../../../redux/global-routing-packs/action";
import { selectRoutingPacksListItems } from "../../../../redux/global-routing-packs/selector";
import { bluePrintRegistries } from "../../../../redux/global-dbn-blueprint-registry/action";
import { selectBluePrintRegistriesListItems } from "../../../../redux/global-dbn-blueprint-registry/selector";

const GlobalDbnRoutingPacks = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const result = useSelector(selectCurrent)
    const [pageData, setPageData] = useState(1)
    const [pageSize, setPageSize] = useState(10);
    const [categoriesComparisonData, setCategoriesComparisonData] = useState<any>();
    const [categoriesListData, setCategoriesListData] = useState<any>();
    const [uploadFor, setUploadFor] = useState('create');
    const [showComparisonPopup, setShowComparisonPopup] = useState<boolean>(false);
    const { header, footer, currency } = result
    const libraryData = useSelector(selectListItems)
    const { getUploadModal } = useAppSelector(selectCurrent)
    const listGlobalDbnRoutingModelsData = useSelector(selectRoutingPacksListItems)
       
    const createGlobalDbnTaxonomyCategoryData = useSelector(selectGlobalDbnTaxonomyCategoriesCreatedItem)
    const compareGlobalDbnTaxonomyCategoryData = useSelector(selectGlobalDbnTaxonomyCategoriesCompareItem)
    const updateGlobalDbnTaxonomyCategoryData = useSelector(selectGlobalDbnTaxonomyCategoriesUpdatedItem)
    const deleteGlobalDbnTaxonomyCategoryData = useSelector(selectGlobalDbnTaxonomyCategoriesDeletedItem)
    const [columnDefs, setColumnDefs] = useState({});
    const [searchCriteriaList, setSearchCriteriaList] = useState<any>([]);

    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: "Sl",
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: "Sl",
                cellRenderer(params: any) {
                    return parseInt(params.node.id, 10) + 1;
                },
            },

            {
                field: "PackName",
                headerName: "Name",
                searchField: "Name",
                sortable: true,
                filter: true,
                filterType: "text",
            },

            {
                field: "PackCode",
                headerName: "Code",
                searchField: "Code",
                sortable: true,
                filter: true,
                filterType: "text",
            },

          
            {
                field: "CommercialTierId",
                headerName: "commercial Type tier",
                searchField: "CommercialTierId",
                sortable: true,
                filter: true,
                filterType: "text",
                cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.CommercialTier },
            },
            
            {
                field: "CreatedOnUtc",
                headerName: "Created On",
                searchField: "CreatedOnUtc",
                sortable: true,
                filter: true,
                filterType: "text",
                cellRenderer: (params: any) => {
                    return params?.value
                        ? new Date(params.value).toISOString().split("T")[0]
                        : "--";
                },
            },

            {
                field: "ModifiedOnUtc",
                headerName: "Modified On",
                searchField: "ModifiedOnUtc",
                sortable: true,
                filter: true,
                filterType: "text",
                cellRenderer: (params: any) => {
                    return params?.value
                        ? new Date(params.value).toISOString().split("T")[0]
                        : "--";
                },
            },
        ]);
    };

    const fetchroutingModels = async () => {
        await dispatch(routingPacks.resetAction({ actionType: 'list' }))
        await dispatch(routingPacks.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-dbn-cloud/dbn-routing/routing-packs/fetch`,
            entity: 'routingPacks',
            jsonData:
            {
                "Context": {},
                "Records": [
                    {}
                ],
                "Pagination": {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "GlobalDBNRoutingModelId",
                    "SortOrder": "desc"
                }
            }
        }))
    }

    const handleAdd = () => {
        navigate(`${0}`)
    }

    const handleSelect = (data: any) => {
    }

    const handleEdit = (data: any) => {
        navigate(`${data.GlobalRoutingPackId }`)
    }

    const handleSearch = async (data: any) => {
        let searchCriteria = {};
        if (data?.column) {
            searchCriteria = [{
                FieldName: data?.column || data?.searchCriteriaList,
                FieldText: data?.column || data?.searchCriteriaList,
                FieldType: 'text',
                FilterOperatorId: data?.filterOperatorId || 6,
                FieldValue: data?.value
            }]
        } else {
            searchCriteria = [{
                FieldName: "Name",
                FieldText: "Name",
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        }
        await dispatch(routingPacks.resetAction({ actionType: 'list' }))
        await dispatch(routingPacks.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-dbn-cloud/dbn-routing/routing-packs/fetch`,
            entity: 'routingModels',
            jsonData:
            {
                "Context": {},
                "Records": [
                    {}
                ],
                "Pagination": {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "GlobalDBNDomainId",
                    "SortOrder": "desc",
                    "Searches": searchCriteria,
                }
            }
        }));
    }


    const additionButtons: any = [
        {
            name: (
                <div className="flex items-center gap-2">
                    {/* Plus Icon */}
                    <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
                        <path
                            d="M12 5V19M5 12H19"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
            ),
            callback: () => handleAdd(),
        },
        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
                    <title>Reload this table</title>
                    <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>,
            // name: 'Reload',
            callback: () => handleReloadData(),
        },
    ];

    const handleReloadData = () => {
        fetchroutingModels();
    }

    const handleUploadCategoriesClick = () => {
        setUploadFor('create')
        dispatch(settings.set({ getUploadModal: 'open' }))
    };

    const handleCompareCategoriesClick = () => {
        setUploadFor('compare')
        dispatch(settings.set({ getUploadModal: 'open' }))
    };
      const fetchbluePrintRegistries = async () => {
            await dispatch(bluePrintRegistries.resetAction({ actionType: 'list' }))
            await dispatch(bluePrintRegistries.list({
                url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-dbn-cloud/dbn-routing/blue-print-registries/fetch`,
                entity: 'bluePrintRegistries',
                jsonData:
                {
                    "Context": {},
                    "Records": [
                        {}
                    ],
                    "Pagination": {
                        "PageNumber": pageData,
                        "PageSize": pageSize,
                        "SortField": "GlobalDBNRoutingModelId",
                        "SortOrder": "desc"
                    }
                }
            }))
        }
    

    const handleDelete = async (data: any) => {
        await dispatch(routingModels.resetAction({ actionType: 'delete' }))
        await dispatch(routingModels.delete({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-dbn-cloud/dbn-routing/routing-packs/delete`,
            entity: 'routingModels',
            jsonData: {
                Context: {},
                Records: [
                    {
                        Id: data?.GlobalRoutingPackId

                    }
                ]
            }
        })).then(() => {
            fetchroutingModels();
        });
    }

   
    useEffect(() => {
        const searchCriteria: any = listGlobalDbnRoutingModelsData?.result?.items
            ?.filter((item: any) => item?.Message?.SpecificationAttributeName) // Filter out items with falsy SpecificationAttributeName
            ?.map((item: any) => ({
                FieldName: item.Message.SpecificationAttributeName,
            }));
        setSearchCriteriaList(searchCriteria)
    }, [listGlobalDbnRoutingModelsData]);

    useEffect(() => {
        if (listGlobalDbnRoutingModelsData?.isSuccess) {
            setCategoriesListData(listGlobalDbnRoutingModelsData)
            dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'list' }))
        }
    }, [listGlobalDbnRoutingModelsData]);

    useEffect(() => {
        if (createGlobalDbnTaxonomyCategoryData?.isSuccess) {
            dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'create' }))
            fetchroutingModels();
            toast.info('Routing Model created successfully.')
        }
    }, [createGlobalDbnTaxonomyCategoryData]);

    useEffect(() => {
        if (updateGlobalDbnTaxonomyCategoryData?.isSuccess) {
            dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'update' }))
            toast.info('Routing Model updated successfully.')
        }
    }, [updateGlobalDbnTaxonomyCategoryData]);

    useEffect(() => {
        if (deleteGlobalDbnTaxonomyCategoryData?.isSuccess) {
            dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'delete' }))
            toast.info('Routing Model deleted successfully.')
        }
    }, [deleteGlobalDbnTaxonomyCategoryData]);

    useEffect(() => {
        if (compareGlobalDbnTaxonomyCategoryData?.isSuccess) {
            setCategoriesComparisonData(compareGlobalDbnTaxonomyCategoryData)
            setShowComparisonPopup(true)
            dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'uploadCompare' }))
            // toast.info('Comparison completed successfully.')
        }
    }, [compareGlobalDbnTaxonomyCategoryData]);

    useEffect(() => {
        createColumnDefs()
        fetchroutingModels()
        setShowComparisonPopup(false)
        dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'create' }))
        dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'uploadCreate' }))
        dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'uploadCompare' }))
        dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'update' }))
        dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'delete' }))
    }, [pageData, pageSize])

    return (
        <>
           
            {listGlobalDbnRoutingModelsData?.isLoading ||
                createGlobalDbnTaxonomyCategoryData?.isLoading ||
                updateGlobalDbnTaxonomyCategoryData?.isLoading ||
                deleteGlobalDbnTaxonomyCategoryData?.isLoading ||
                compareGlobalDbnTaxonomyCategoryData?.isLoading ? <PageLoader /> :
                <Table
                    columnData={columnDefs}
                    rowData={categoriesListData?.result?.items}
                    enableFilter={true}
                    setPageData={setPageData}
                    setPageSize={setPageSize}
                    paginationData={categoriesListData?.result?.pagination}
                    onSearch={handleSearch}
                    searchCriteriaList={searchCriteriaList}
                    onSelect={handleSelect}
                    onEdit={handleEdit}
                    onDelete={handleDelete}
                    additionButtons={additionButtons}
                    checkboxConfig={{
                        allowMultiSelect: true,
                        defaultSelectedIds: [],
                        isDisabled: false,
                        keyColumn: 'GlobalDBNCategoryId',
                    }}
                    headingName="Global DBN Routing Packs"
                />
            }
        </>
    );
};

export default GlobalDbnRoutingPacks;

